import { render, staticRenderFns } from "./Critter.vue?vue&type=template&id=26d83fd8&"
import script from "./Critter.vue?vue&type=script&lang=js&"
export * from "./Critter.vue?vue&type=script&lang=js&"
import style0 from "./Critter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Critter.vue"
export default component.exports